<template>
    <div>
        <filter-check-select :show="allowDgItemSelect" @selectedClick="filterSecilenler"
            @close="allowDgItemSelect = false" ref="slcItem"></filter-check-select>

  <v-dialog
      v-model="crdLikert"
      scrollable
      max-width="700px"
    >
              <v-card 
   

  >
      <v-toolbar
            flat
            dark
            color="primary"
          >

            <v-toolbar-title>Yardım</v-toolbar-title>
            <v-spacer></v-spacer>
                       <v-btn
              icon
              dark
              @click="crdLikert = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>

          </v-toolbar>
     <section style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; color: #333; line-height: 1.6; max-width: 800px; margin: 20px auto; padding: 20px; border: 1px solid #e0e0e0; border-radius: 8px; background-color: #ffffff; box-shadow: 0 4px 6px rgba(0,0,0,0.05);">
  
  <h2 style="color: #3f51b5; border-bottom: 2px solid #3f51b5; padding-bottom: 8px; margin-top: 0;">📋 Dönüşüm Senaryoları ve Örnekler</h2>
  <p style="font-size: 15px; color: #555;">Fonksiyon, veri tabanından gelebilecek anket seçenek yapısına göre iki farklı strateji uygulayarak metinsel verileri istatistiksel analizlere hazır hale getirir:</p>

  <div style="margin-bottom: 30px;">
    <h3 style="color: #1a237e; font-size: 18px; margin-bottom: 10px; display: flex; align-items: center;">
      <span style="background-color: #e8eaf6; color: #3f51b5; padding: 4px 10px; border-radius: 4px; margin-right: 10px; font-size: 14px;">Senaryo 1</span> 
      Sayı ile Başlayan Seçenekler (Likert Ölçeği vb.)
    </h3>
    <p style="font-size: 14px; color: #666; margin-bottom: 12px;">Eğer anket seçenekleriniz zaten kendi içinde bir puana sahipse (Örn: <code>1 - Kesinlikle Katılmıyorum</code>), fonksiyon metnin sadece başındaki sayısal karakteri ayıklar.</p>
    
    <table style="width: 100%; border-collapse: collapse; text-align: left; font-size: 14px;">
      <thead>
        <tr style="background-color: #f5f5f5; border-bottom: 2px solid #e0e0e0;">
          <th style="padding: 10px; font-weight: 600;">Gelen Ham Metin (<code>label</code>)</th>
          <th style="padding: 10px; font-weight: 600; color: #3f51b5;">Yakalanan Değer (<code>value</code>)</th>
          <th style="padding: 10px; font-weight: 600; color: #757575;">Açıklama</th>
        </tr>
      </thead>
      <tbody>
        <tr style="border-bottom: 1px solid #eee;">
          <td style="padding: 10px;">"1 - Çok Kötü"</td>
          <td style="padding: 10px; font-weight: bold; color: #3f51b5;">1</td>
          <td style="padding: 10px; color: #757575;">Başındaki "1" karakteri algılanır.</td>
        </tr>
        <tr style="border-bottom: 1px solid #eee; background-color: #fafafa;">
          <td style="padding: 10px;">"3 - Ne İyi Ne Kötü"</td>
          <td style="padding: 10px; font-weight: bold; color: #3f51b5;">3</td>
          <td style="padding: 10px; color: #757575;">Başındaki "3" karakteri algılanır.</td>
        </tr>
        <tr style="border-bottom: 1px solid #eee;">
          <td style="padding: 10px;">"5 - Harika"</td>
          <td style="padding: 10px; font-weight: bold; color: #3f51b5;">5</td>
          <td style="padding: 10px; color: #757575;">Başındaki "5" karakteri algılanır.</td>
        </tr>
        <tr style="border-bottom: 1px solid #eee; background-color: #fafafa;">
          <td style="padding: 10px;">"10 Puan"</td>
          <td style="padding: 10px; font-weight: bold; color: #3f51b5;">10</td>
          <td style="padding: 10px; color: #757575;">Başındaki "10" karakteri algılanır.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div>
    <h3 style="color: #1a237e; font-size: 18px; margin-bottom: 10px; display: flex; align-items: center;">
      <span style="background-color: #e8eaf6; color: #3f51b5; padding: 4px 10px; border-radius: 4px; margin-right: 10px; font-size: 14px;">Senaryo 2</span> 
      Tamamen Metinsel Seçenekler (Nominal / Kategorik)
    </h3>
    <p style="font-size: 14px; color: #666; margin-bottom: 12px;">Eğer seçeneklerinizin başında hiçbir sayısal ibare yoksa, sistem veri setindeki <strong>seçenek sırasını (<code>index</code>)</strong> baz alarak otomatik bir ağırlık oluşturur (<code>index + 1</code>).</p>
    
    <table style="width: 100%; border-collapse: collapse; text-align: left; font-size: 14px;">
      <thead>
        <tr style="background-color: #f5f5f5; border-bottom: 2px solid #e0e0e0;">
          <th style="padding: 10px; font-weight: 600;">Gelen Ham Metin (<code>label</code>)</th>
          <th style="padding: 10px; font-weight: 600; color: #757575;">Dizi İndeksi (<code>index</code>)</th>
          <th style="padding: 10px; font-weight: 600; color: #e91e63;">Üretilen Değer (<code>index + 1</code>)</th>
        </tr>
      </thead>
      <tbody>
        <tr style="border-bottom: 1px solid #eee;">
          <td style="padding: 10px;">"Hiç Katılmıyorum"</td>
          <td style="padding: 10px; color: #757575;">0</td>
          <td style="padding: 10px; font-weight: bold; color: #e91e63;">1</td>
        </tr>
        <tr style="border-bottom: 1px solid #eee; background-color: #fafafa;">
          <td style="padding: 10px;">"Katılmıyorum"</td>
          <td style="padding: 10px; color: #757575;">1</td>
          <td style="padding: 10px; font-weight: bold; color: #e91e63;">2</td>
        </tr>
        <tr style="border-bottom: 1px solid #eee;">
          <td style="padding: 10px;">"Kararsızım"</td>
          <td style="padding: 10px; color: #757575;">2</td>
          <td style="padding: 10px; font-weight: bold; color: #e91e63;">3</td>
        </tr>
        <tr style="border-bottom: 1px solid #eee; background-color: #fafafa;">
          <td style="padding: 10px;">"Katılıyorum"</td>
          <td style="padding: 10px; color: #757575;">3</td>
          <td style="padding: 10px; font-weight: bold; color: #e91e63;">4</td>
        </tr>
        <tr style="border-bottom: 1px solid #eee;">
          <td style="padding: 10px;">"Kesinlikle Katılıyorum"</td>
          <td style="padding: 10px; color: #757575;">4</td>
          <td style="padding: 10px; font-weight: bold; color: #e91e63;">5</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div style="margin-top: 25px; padding: 15px; background-color: #fffde7; border-left: 4px solid #fbc02d; border-radius: 4px;">
    <h4 style="margin: 0 0 5px 0; color: #f57f17; font-size: 15px;">⚠️ Önemli Kural</h4>
    <p style="margin: 0; font-size: 13px; color: #5d4037;">
      Tamamen metinsel olan (Senaryo 2) anketlerde doğru bir Ortalama ve Medyan sonucu alabilmek için, seçeneklerin mantıksal olarak <strong>küçükten büyüğe</strong> ya da <strong>olumsuzdan olumluya</strong> doğru sıralanmış olması şarttır. Rastgele sıralamalarda indeks tabanlı ağırlıklandırma yanıltıcı sonuçlar verebilir.
    </p>
  </div>

</section>
  


   
  </v-card>
    </v-dialog>



        <v-card>
            <v-toolbar dark color="primary">

                <v-toolbar-title> Form Tasarımı</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-tooltip bottom>

                        <template v-slot:activator="{ on, attrs }">

                            <v-btn dark icon v-bind="attrs" v-on="on"
                                :href="$router.resolve({ name: 'AdminFormOnGosterim', params: { id: $route.params.id } }).href"
                                target="_blank">

                                <v-icon>mdi-view-day</v-icon>
                            </v-btn>
                            <!-- <router-link v-bind="attrs" v-on="on" :to="{ name: 'AdminFormOnGosterim', params: { id: $route.params.id } }" target="_blank">
          <v-icon>mdi-view-day</v-icon>
</router-link> -->
                        </template>
                        <span>Ön İzleme</span>
                    </v-tooltip>

                </v-toolbar-items>
                <v-toolbar-items>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn dark icon @click="validate" v-bind="attrs" v-on="on">

                                <v-icon>mdi-content-save</v-icon>
                            </v-btn>
                        </template>
                        <span>Kaydet</span>
                    </v-tooltip>

                </v-toolbar-items>
            </v-toolbar>


            <v-card-text class="card-content">

                <v-form ref="frmFieldList">


                    <v-row>
                        <v-col cols="8" sm="6" md="6" lg="8" xl="8">
                            <v-container class="">




                                <draggable v-model="myList" group="people" @change="onChange" class="drop-zone row"
                                    min-height="550">

                                    <v-col :class="{ primary: field.id == selectedField.id }" :cols="field.cols"
                                        class="sddf" v-for="(field, index) in fields" @click="rowEdit(field)"
                                        :key="field.id">
                                        <v-list-item :class="{ primary: field.id == selectedField.id }"
                                            class="pa-4 v-card v-sheet theme--light" :key="`ls_` + field.id">

                                            <v-list-item-avatar>
                                                <v-app-bar-nav-icon></v-app-bar-nav-icon>
                                            </v-list-item-avatar>

                                            <v-list-item-content :class="{ disabled: field.disable }">



                                                <component v-bind:is="field.cmpName" :ayar="field" :editProp="true"
                                                    :class="{ selectedItemClass: field.id == selectedField.id }"
                                                    @setClick="setClickChange" @triggerEvent="triggerEvent">

                                                </component>





                                            </v-list-item-content>

                                            <v-list-item-action class="action-top-right d-flex flex-row">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">

                                                        <v-btn icon v-bind="attrs" v-on="on">
                                                            <v-icon v-if="!field.disable"
                                                                @click="deleteField(field, index)"
                                                                color="grey lighten-1">mdi-delete</v-icon>
                                                            <v-icon v-else @click="deleteField(field, index)"
                                                                color="grey lighten-1">mdi-wrap-disabled</v-icon>

                                                        </v-btn>
                                                    </template>
                                                    <span>{{ !field.disable ? 'Sil' : 'Aktifleştir' }}</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">

                                                        <v-btn icon v-bind="attrs" v-on="on"
                                                            @click="copyField(field, index)">
                                                            <v-icon color="grey lighten-1">mdi-content-copy</v-icon>


                                                        </v-btn>
                                                    </template>
                                                    <span>Kopyala</span>
                                                </v-tooltip>

                                            </v-list-item-action>

                                        </v-list-item>
                                    </v-col>

                                </draggable>







                                <!-- 
                                <v-list subheader two-line min-height="350" height="450" scrool>
                                    <draggable v-model="myList" group="people" @change="onChange" class="drop-zone"
                                        min-height="550">

                                        <v-list-item :class="{ primary: field.id == selectedField.id }"
                                            v-for="(field, index) in fields" @click="rowEdit(field)" :key="field.id">

                                            <v-list-item-avatar>
                                                <v-app-bar-nav-icon></v-app-bar-nav-icon>
                                            </v-list-item-avatar>

                                            <v-list-item-content>



                                                <component v-bind:is="field.cmpName" :ayar="field" :editProp="true"
                                                    :class="{ selectedItemClass: field.id == selectedField.id }"
                                                    @setClick="setClickChange" @triggerEvent="triggerEvent">

                                                </component>





                                            </v-list-item-content>

                                            <v-list-item-action class="action-top-right d-flex flex-row">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">

                                                        <v-btn icon v-bind="attrs" v-on="on">
                                                            <v-icon v-if="!field.disable"
                                                                @click="deleteField(field, index)"
                                                                color="grey lighten-1">mdi-delete</v-icon>
                                                            <v-icon v-else @click="deleteField(field, index)"
                                                                color="grey lighten-1">mdi-wrap-disabled</v-icon>

                                                        </v-btn>
                                                    </template>
                                                    <span>{{ !field.disable ? 'Sil' : 'Aktifleştir' }}</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">

                                                        <v-btn icon v-bind="attrs" v-on="on"
                                                            @click="copyField(field, index)">
                                                            <v-icon color="grey lighten-1">mdi-content-copy</v-icon>


                                                        </v-btn>
                                                    </template>
                                                    <span>Kopyala</span>
                                                </v-tooltip>

                                            </v-list-item-action>

                                        </v-list-item>

                                    </draggable>
                                </v-list> -->






                                <!-- <v-row>
                            <v-col>

                                <v-btn color="success" class="mr-4" @click="validate">
                                    Geçerliği Sına
                                </v-btn>

                            </v-col>
                        </v-row> -->
                            </v-container>

                        </v-col>
                        <v-col cols="4" sm="6" md="6" lg="4" xl="4">

                            <v-container>
                                <v-tabs v-model="tab" fixed-tabs>

                                    <v-tab class="primary--text">
                                        <v-icon>mdi-list-box</v-icon>Ekle
                                    </v-tab>



                                    <v-tab class="primary--text">
                                        <v-icon>mdi-cogs</v-icon> Özellikler
                                    </v-tab>


                                    <v-tab-item>





                                        <draggable v-model="itemTypeList"
                                            :group="{ name: 'people', pull: 'clone', put: false }" sort="false"
                                            class="row" :clone="cloneAction">
                                            <!-- style="background: darkturquoise;" -->
                                            <div class="col-5 ma-1 pa-1" v-for="(item, i) in itemTypeList" :key="i">
                                                <v-list-item style="background: #7EC8E3;" background-color="primary"
                                                    link>
                                                    <v-list-item-avatar>
                                                        <v-icon large color="blue darken-2">
                                                            {{ item.icon }}
                                                        </v-icon>
                                                    </v-list-item-avatar>

                                                    <v-list-item-content>
                                                        <v-list-item-title>

                                                            {{ item.label }}
                                                        </v-list-item-title>


                                                    </v-list-item-content>


                                                </v-list-item>
                                                <v-divider></v-divider>
                                            </div>




                                        </draggable>




                                    </v-tab-item>

                                    <v-tab-item>
                                        <v-card color="basil" v-if="selectedField.type === 'text'" flat>
                                            <v-card-text>

                                                <v-form ref="form" v-model="valid" lazy-validation>

                                                    <v-row>
                                                        <v-col cols="6"> <v-text-field label="Etiket"
                                                                v-model="selectedField.label"></v-text-field>
                                                        </v-col>
                                                        <v-col cols="6"> <v-text-field label="Kısa Açıklama"
                                                                v-model="selectedField.hint"></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="6"> <v-text-field label="Yer tutucu"
                                                                v-model="selectedField.placeholder"></v-text-field>
                                                        </v-col>
                                                        <v-col cols="6"> <v-text-field label="Grup Adı"
                                                                v-model="selectedField.grpName"></v-text-field>
                                                        </v-col>
                                                    </v-row>



                                                    <v-row>
                                                        <v-col cols="4">
                                                            <v-text-field label="Ön Ek"
                                                                v-model="selectedField.prefix"></v-text-field>
                                                        </v-col>
                                                        <v-col cols="4">
                                                            <v-text-field label="Son Ek"
                                                                v-model="selectedField.suffix"></v-text-field>
                                                        </v-col>
                                                        <v-col cols="4">
                                                            <v-select label="Genişlik" v-model="selectedField.cols"
                                                                :items="colsOptions" item-text="text"
                                                                item-value="value"></v-select>
                                                        </v-col>

                                                    </v-row>


                                                    <v-row>
                                                        <v-col cols="6"><v-checkbox v-model="selectedField.required"
                                                                label="Gerekli"
                                                                @change="check($event)"></v-checkbox></v-col>
                                                        <v-col cols="6">
                                                            <v-checkbox v-model="selectedField.identity"
                                                                hint="Bu alana girilen veri bir defa girilebilir.ÖRN:Her kişi bir defa başvursun isterseniz TC alanı oluşturup bunu da 'Benzersiz cevap iste' yapmalısınız. "
                                                                label="Benzersiz cevap iste"></v-checkbox>
                                                        </v-col>
                                                    </v-row>
                                                    <v-dialog v-model="dgMask" width="700">

                                                        <v-card>
                                                            <v-toolbar dark color="primary">

                                                                <v-toolbar-title> Maskeleme Yardım</v-toolbar-title>
                                                                <v-spacer></v-spacer>
                                                                <v-toolbar-items>
                                                                    <v-btn icon dark @click="dgMask = false">
                                                                        <v-icon>mdi-close</v-icon>
                                                                    </v-btn>
                                                                </v-toolbar-items>
                                                            </v-toolbar>


                                                            <v-card-text>
                                                                <MaskHelp></MaskHelp>


                                                            </v-card-text>

                                                            <v-divider></v-divider>


                                                        </v-card>
                                                    </v-dialog>

                                                    <v-text-field type="text" hint="  ÖRN:  TR AA99##-##"
                                                        v-model="selectedField.mask">
                                                        <template v-slot:label>
                                                            <div>
                                                                Giriş Maskesi
                                                                (Örnek için
                                                                tıklayınız) <v-icon @click="dgMask = true;"
                                                                    color="primary darken-2">
                                                                    mdi-help
                                                                </v-icon>
                                                                <!-- <a href="/Form/Bilgi" target="_blank"></a> -->


                                                            </div>
                                                        </template>
                                                    </v-text-field>

                                                    <v-expansion-panels>
                                                        <v-expansion-panel>
                                                            <v-expansion-panel-header>
                                                                Dinamik Koşul Oluşturucu
                                                            </v-expansion-panel-header>
                                                            <v-expansion-panel-content>
                                                                <ConditionBuilder
                                                                    :fields="seciliItemHaricDigerItemlar()"
                                                                    v-model="selectedField.visibleIf" />
                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>





                                                </v-form>



                                            </v-card-text>
                                        </v-card>
                                        <v-card color="basil" v-if="selectedField.type === 'mail'" flat>
                                            <v-card-text>

                                                <v-form ref="form" v-model="valid" lazy-validation>
                                                    <!-- {{ selectedField.id }} -->
                                                    <v-row>
                                                        <v-col> <v-text-field label="Etiket"
                                                                v-model="selectedField.label"></v-text-field></v-col>
                                                        <v-col> <v-text-field label="Kısa Açıklama"
                                                                v-model="selectedField.hint"></v-text-field></v-col>
                                                    </v-row>

                                                    <v-row>
                                                        <v-col><v-text-field label="Yer tutucu"
                                                                v-model="selectedField.placeholder"></v-text-field></v-col>
                                                        <v-col><v-text-field label="Grup Adı"
                                                                v-model="selectedField.grpName"></v-text-field></v-col>
                                                    </v-row>


                                                    <v-row>
                                                        <v-col cols="5">
                                                            <v-text-field label="Ön Ek"
                                                                v-model="selectedField.prefix"></v-text-field>
                                                        </v-col>
                                                        <v-col cols="5">
                                                            <v-text-field label="Son Ek"
                                                                v-model="selectedField.suffix"></v-text-field>
                                                        </v-col>

                                                    </v-row>


                                                    <v-row>
                                                        <v-col cols="4"> <v-select label="Genişlik"
                                                                v-model="selectedField.cols" :items="colsOptions"
                                                                item-text="text" item-value="value"
                                                                dense></v-select></v-col>
                                                        <v-col cols="4"> <v-checkbox v-model="selectedField.required"
                                                                label="Gerekli"
                                                                @change="check($event)"></v-checkbox></v-col>
                                                        <v-col cols="4"> <v-checkbox v-model="selectedField.identity"
                                                                label="Benzersiz cevap iste"></v-checkbox></v-col>
                                                    </v-row>


                                                    <!-- <v-text-field type="text" hint="  ÖRN:  TR AA99##-##"
                                                        v-model="selectedField.mask">
                                                        <template v-slot:label>
                                                            <div>
                                                                Giriş Maskesi
                                                                <a href="/Form/Bilgi" target="_blank">(Örnek için
                                                                    tıklayınız)</a>


                                                            </div>
                                                        </template>
                                                    </v-text-field> -->


                                                    <v-expansion-panels>
                                                        <v-expansion-panel>
                                                            <v-expansion-panel-header>
                                                                Dinamik Koşul Oluşturucu
                                                            </v-expansion-panel-header>
                                                            <v-expansion-panel-content>
                                                                <ConditionBuilder
                                                                    :fields="seciliItemHaricDigerItemlar()"
                                                                    v-model="selectedField.visibleIf" />
                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>

                                                </v-form>



                                            </v-card-text>
                                        </v-card>
                                        <v-card color="basil" v-if="selectedField.type === 'number'" flat>
                                            <v-card-text>

                                                <v-form ref="form" v-model="valid" lazy-validation>

                                                    <v-row>
                                                        <v-col> <v-text-field label="Etiket"
                                                                v-model="selectedField.label"></v-text-field></v-col>
                                                        <v-col> <v-text-field label="Kısa Açıklama"
                                                                v-model="selectedField.hint"></v-text-field></v-col>
                                                    </v-row>

                                                    <v-row>
                                                        <v-col> <v-text-field label="Yer tutucu"
                                                                v-model="selectedField.placeholder"></v-text-field></v-col>
                                                        <v-col> <v-text-field label="Grup Adı"
                                                                v-model="selectedField.grpName"></v-text-field></v-col>
                                                    </v-row>



                                                    <v-row>
                                                        <v-col cols="4">
                                                            <v-text-field label="Ön Ek"
                                                                v-model="selectedField.prefix"></v-text-field>
                                                        </v-col>
                                                        <v-col cols="4">
                                                            <v-text-field label="Son Ek"
                                                                v-model="selectedField.suffix"></v-text-field>
                                                        </v-col>
                                                        <v-col cols="4">
                                                            <v-select label="Genişlik" v-model="selectedField.cols"
                                                                :items="colsOptions" item-text="text"
                                                                item-value="value"></v-select>
                                                        </v-col>

                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="3"> <v-checkbox v-model="selectedField.required"
                                                                label="Gerekli"
                                                                @change="check($event)"></v-checkbox></v-col>
                                                        <v-col cols="9"> <v-text-field type="text"
                                                                hint="  ÖRN:  TR AA99##-##"
                                                                v-model="selectedField.mask">
                                                                <template v-slot:label>
                                                                    <div>
                                                                        Giriş Maskesi
                                                                        <a href="/Form/Bilgi" target="_blank">(Örnek
                                                                            için
                                                                            tıklayınız)</a>


                                                                    </div>
                                                                </template>
                                                            </v-text-field></v-col>
                                                    </v-row>




                                                    <v-checkbox v-model="selectedField.identity"
                                                        label="Benzersiz cevap iste"></v-checkbox>
                                                    <v-expansion-panels>
                                                        <v-expansion-panel>
                                                            <v-expansion-panel-header>
                                                                Dinamik Koşul Oluşturucu
                                                            </v-expansion-panel-header>
                                                            <v-expansion-panel-content>
                                                                <ConditionBuilder
                                                                    :fields="seciliItemHaricDigerItemlar()"
                                                                    v-model="selectedField.visibleIf" />
                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                </v-form>



                                            </v-card-text>
                                        </v-card>
                                        <v-card color="basil" v-if="selectedField.type === 'radio'" flat>
                                            <v-card-text>

                                                <v-container>
                                                    <v-row>
                                                        <v-col> <v-text-field label="Etiket"
                                                                v-model="selectedField.label"></v-text-field></v-col>
                                                        <v-col> <v-text-field label="Kısa Açıklama"
                                                                v-model="selectedField.hint"></v-text-field></v-col>
                                                    </v-row>

                                                    <v-row>
                                                        <v-col> <v-text-field label="Grup Adı"
                                                                v-model="selectedField.grpName"></v-text-field></v-col>
                                                        <v-col> <v-checkbox v-model="selectedField.required"
                                                                @change="check($event)"
                                                                label="Gerekli"></v-checkbox></v-col>
                                                    </v-row>

                                                    <v-row>
                                                        <v-col><v-checkbox v-model="selectedField.columngosterim"
                                                                label="Kolonlu Gösterim"></v-checkbox></v-col>
                                                        <v-col><v-select label="Genişlik" v-model="selectedField.cols"
                                                                :items="colsOptions" item-text="text" item-value="value"
                                                                dense></v-select></v-col>
                                                    </v-row>

                                                    <v-expansion-panels class="my-2">
                                                        <v-expansion-panel>
                                                            <v-expansion-panel-header>
                                                                Seçenekler
                                                            </v-expansion-panel-header>
                                                            <v-expansion-panel-content>
                                                                <v-card elevation="2">
                                                                    <!-- <v-list-item three-line>
                                                                        <v-list-item-content>
                                                                            <div class="text-overline mb-4">
                                                                                Seçenekler Ekle(Her satıra bir tane)
                                                                            </div>
                                                                            <v-list-item-title class="text-h5 mb-1">
                                                                                <v-textarea ref="taSecenekler"
                                                                                    v-model="itemSumList"
                                                                                    label="Seçenekler"></v-textarea>
                                                                            </v-list-item-title>

                                                                        </v-list-item-content>

                                                                        <v-card-actions>
                                                                            <v-btn outlined @click="seceneklerRadioEkle"
                                                                                center text>
                                                                                Ekle
                                                                            </v-btn>
                                                                        </v-card-actions>
                                                                    </v-list-item> -->

                                                                    <v-toolbar color="indigo" dark>


                                                                        <v-toolbar-title>Seçenekler</v-toolbar-title>

                                                                        <v-spacer></v-spacer>
                                                                        <v-tooltip bottom>
                                                                            <template v-slot:activator="{ on, attrs }">

                                                                                <v-btn icon @click="itemSelectClick"
                                                                                    v-bind="attrs" dark v-on="on">
                                                                                    <v-icon>mdi-location-enter</v-icon>
                                                                                </v-btn>


                                                                            </template>
                                                                            <span>Hızlı Giriş</span>
                                                                        </v-tooltip>

                                                                    </v-toolbar>
                                                                </v-card>


                                                                <v-simple-table height="250px">
                                                                    <template v-slot:default>
                                                                        <thead>
                                                                            <tr>
                                                                                <th class="text-left">
                                                                                    İsim
                                                                                </th>
                                                                                <th colspan="2" class="text-left">
                                                                                    <!-- <v-checkbox
                                                                                        v-model="selectedField.multiItemShow"
                                                                                        label="Hızlı Giriş"></v-checkbox> -->
                                                                                </th>

                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr v-for="(item, i) in selectedField.items"
                                                                                :key="i">
                                                                                <td> <v-text-field clearable
                                                                                        @input="inputItem(item, i, target)"
                                                                                        v-model="item.name"></v-text-field>
                                                                                </td>
                                                                                <td width="50px">
                                                                                    <v-btn icon>
                                                                                        <v-icon color="grey lighten-1"
                                                                                            @click="addSelectItem(item, i)">mdi-plus</v-icon>
                                                                                    </v-btn>
                                                                                </td>
                                                                                <td width="50px">

                                                                                    <v-btn icon>
                                                                                        <v-icon color="grey lighten-1"
                                                                                            @click="deleteSelectItem(item, i)">mdi-delete</v-icon>
                                                                                    </v-btn>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </template>
                                                                </v-simple-table>
                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>


                                                    <v-expansion-panels>
                                                        <v-expansion-panel>
                                                            <v-expansion-panel-header>
                                                                Dinamik Koşul Oluşturucu
                                                            </v-expansion-panel-header>
                                                            <v-expansion-panel-content>
                                                                <ConditionBuilder
                                                                    :fields="seciliItemHaricDigerItemlar()"
                                                                    v-model="selectedField.visibleIf" />
                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>



                                                </v-container>



                                            </v-card-text>
                                        </v-card>
                                        <v-card color="basil" v-if="selectedField.type === 'select'" flat>
                                            <v-card-text>




                                                <v-container>
                                                    <v-row>
                                                        <v-col> <v-text-field label="Etiket"
                                                                v-model="selectedField.label"></v-text-field></v-col>
                                                        <v-col>
                                                            <v-text-field label="Kısa Açıklama"
                                                                v-model="selectedField.hint"></v-text-field></v-col>
                                                    </v-row>

                                                    <v-row>
                                                        <v-col> <v-text-field label="Grup Adı"
                                                                v-model="selectedField.grpName"></v-text-field></v-col>
                                                        <v-col> <v-checkbox v-model="selectedField.required"
                                                                label="Gerekli"
                                                                @change="check($event)"></v-checkbox></v-col>
                                                        <v-col> <v-checkbox v-model="selectedField.multi"
                                                                label="Çoklu Seçim"></v-checkbox></v-col>
                                                    </v-row>







                                                    <v-container>
                                                        <v-row>
                                                            <v-col>
                                                                <v-checkbox v-model="selectedField.trigger"
                                                                    @change="triggerChange"
                                                                    label="Tetikle"></v-checkbox>
                                                            </v-col>
                                                            <v-col>
                                                                <v-select :items="selectedField.triggerItems"
                                                                    @@change="triggerSelectedItemChange($event, selectedField.triggerSelectedItem)"
                                                                    item-value="id" item-text="name"
                                                                    v-model="selectedField.triggerId"></v-select>
                                                            </v-col>
                                                        </v-row>
                                                    </v-container>

                                                    <v-select label="Genişlik" v-model="selectedField.cols"
                                                        :items="colsOptions" item-text="text" item-value="value"
                                                        dense></v-select>


                                                    <v-expansion-panels class="my-2">
                                                        <v-expansion-panel>
                                                            <v-expansion-panel-header>
                                                                Seçenekler
                                                            </v-expansion-panel-header>
                                                            <v-expansion-panel-content>
                                                                <v-card elevation="2">


                                                                    <v-toolbar color="indigo" dark>


                                                                        <v-toolbar-title>Seçenekler</v-toolbar-title>

                                                                        <v-spacer></v-spacer>
                                                                        <v-tooltip bottom>
                                                                            <template v-slot:activator="{ on, attrs }">

                                                                                <v-btn icon @click="itemSelectClick"
                                                                                    v-bind="attrs" dark v-on="on">
                                                                                    <v-icon>mdi-location-enter</v-icon>
                                                                                </v-btn>


                                                                            </template>
                                                                            <span>Hızlı Giriş</span>
                                                                        </v-tooltip>

                                                                    </v-toolbar>
                                                                    <!-- <v-list-item three-line>
                                                                        <v-list-item-content>
                                                                            <div class="text-overline mb-4">
                                                                                Seçenekler Ekle(Her satıra bir tane)
                                                                            </div>
                                                                            <v-list-item-title class="text-h5 mb-1">
                                                                                <v-textarea ref="taSecenekler" solo
                                                                                    v-model="itemSumList"
                                                                                    :placeholder="getTriggerSumDataFormat">

                                                                                </v-textarea>
                                                                                @*placeholder="Kırmızı &#10; Yeşil &#10;
                                                                                Mavi
                                                                                "*@
                                                                            </v-list-item-title>

                                                                        </v-list-item-content>

                                                                        <v-card-actions>
                                                                            <v-btn outlined @click="seceneklerEkle"
                                                                                center text>
                                                                                Ekle
                                                                            </v-btn>
                                                                        </v-card-actions>
                                                                    </v-list-item> -->
                                                                    <v-simple-table height="250px">
                                                                        <template v-slot:default>
                                                                            <thead>
                                                                                <tr>
                                                                                    <th class="text-left">
                                                                                        İsim
                                                                                    </th>
                                                                                    <th colspan="2" class="text-left">
                                                                                        <!-- <v-checkbox
                                                                                        v-model="selectedField.multiItemShow"
                                                                                        label="Hızlı Giriş"></v-checkbox> -->
                                                                                    </th>

                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr v-for="(item, i) in selectedField.store"
                                                                                    :key="i">
                                                                                    <td> <v-text-field clearable
                                                                                            @input="inputItem(item, i, target)"
                                                                                            v-model="item.name"></v-text-field>
                                                                                    </td>
                                                                                    <td width="50px">
                                                                                        <v-btn icon>
                                                                                            <v-icon
                                                                                                color="grey lighten-1"
                                                                                                @click="addSelectItem2(item, i)">mdi-plus</v-icon>
                                                                                        </v-btn>
                                                                                    </td>
                                                                                    <td width="50px">

                                                                                        <v-btn icon>
                                                                                            <v-icon
                                                                                                color="grey lighten-1"
                                                                                                @click="deleteSelectItem2(item, i)">mdi-delete</v-icon>
                                                                                        </v-btn>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </template>
                                                                    </v-simple-table>

                                                                </v-card>






                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels>
                                                        <v-expansion-panel>
                                                            <v-expansion-panel-header>
                                                                Dinamik Koşul Oluşturucu
                                                            </v-expansion-panel-header>
                                                            <v-expansion-panel-content>
                                                                <ConditionBuilder
                                                                    :fields="seciliItemHaricDigerItemlar()"
                                                                    v-model="selectedField.visibleIf" />
                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                </v-container>











                                            </v-card-text>
                                        </v-card>
                                        <v-card color="basil" v-if="selectedField.type === 'date'" flat>
                                            <v-card-text>

                                                <v-form ref="form" v-model="valid" lazy-validation>

                                                    <v-row>
                                                        <v-col>
                                                            <v-text-field label="Etiket"
                                                                v-model="selectedField.label"></v-text-field>
                                                        </v-col>
                                                        <v-col>
                                                            <v-text-field label="Kısa Açıklama"
                                                                v-model="selectedField.hint"></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col>
                                                            <v-text-field label="Yer tutucu"
                                                                v-model="selectedField.placeholder"></v-text-field>
                                                        </v-col>
                                                        <v-col>
                                                            <v-text-field label="Grup Adı"
                                                                v-model="selectedField.grpName"></v-text-field>
                                                        </v-col>
                                                    </v-row>



                                                    <v-row>
                                                        <v-col cols="5">
                                                            <VCustomDate v-model="selectedField.min" label="En Az">
                                                            </VCustomDate>

                                                        </v-col>
                                                        <v-col cols="5">
                                                            <VCustomDate v-model="selectedField.max" label="En Fazla">
                                                            </VCustomDate>
                                                        </v-col>

                                                    </v-row>
                                                    <v-row>
                                                        <v-col>
                                                            <v-checkbox v-model="selectedField.required" label="Gerekli"
                                                                @change="check($event)"></v-checkbox>
                                                        </v-col>
                                                        <v-col>
                                                            <v-select label="Genişlik" v-model="selectedField.cols"
                                                                :items="colsOptions" item-text="text" item-value="value"
                                                                dense></v-select>
                                                        </v-col>
                                                        <v-col>
                                                            <v-checkbox v-model="selectedField.identity"
                                                                label="Benzersiz cevap iste"></v-checkbox>
                                                        </v-col>
                                                    </v-row>







                                                    <v-expansion-panels>
                                                        <v-expansion-panel>
                                                            <v-expansion-panel-header>
                                                                Dinamik Koşul Oluşturucu
                                                            </v-expansion-panel-header>
                                                            <v-expansion-panel-content>
                                                                <ConditionBuilder
                                                                    :fields="seciliItemHaricDigerItemlar()"
                                                                    v-model="selectedField.visibleIf" />
                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                </v-form>



                                            </v-card-text>
                                        </v-card>
                                        <v-card color="basil" v-if="selectedField.type === 'dateHtml'" flat>
                                            <v-card-text>

                                                <v-form ref="form" v-model="valid" lazy-validation>

                                                    <v-row>
                                                        <v-col>
                                                            <v-text-field label="Etiket"
                                                                v-model="selectedField.label"></v-text-field>
                                                        </v-col>
                                                        <v-col>
                                                            <v-text-field label="Kısa Açıklama"
                                                                v-model="selectedField.hint"></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col>
                                                            <v-text-field label="Yer tutucu"
                                                                v-model="selectedField.placeholder"></v-text-field>
                                                        </v-col>
                                                        <v-col>
                                                            <v-text-field label="Grup Adı"
                                                                v-model="selectedField.grpName"></v-text-field>
                                                        </v-col>
                                                    </v-row>



                                                    <v-row>
                                                        <v-col cols="4">
                                                            <v-select label="Tür" v-model="selectedField.dateType"
                                                                :items="dateTypes" item-text="name" item-value="id"
                                                                dense></v-select>

                                                        </v-col>
                                                        <v-col cols="4">

                                                            <VDateHtml v-if="selectedField.dateType != 'time'"
                                                                v-model="selectedField.min" :ayar="{ label: 'En az' }"
                                                                label="En Az">
                                                            </VDateHtml>
                                                            <!-- <VCustomDate v-model="selectedField.min" label="En Az">
                                                            </VCustomDate> -->

                                                        </v-col>
                                                        <v-col cols="4">
                                                            <VDateHtml v-if="selectedField.dateType != 'time'"
                                                                v-model="selectedField.max"
                                                                :ayar="{ label: 'En Fazla' }">
                                                            </VDateHtml>
                                                        </v-col>

                                                    </v-row>
                                                    <v-row>
                                                        <v-col>
                                                            <v-checkbox v-model="selectedField.required" label="Gerekli"
                                                                @change="check($event)"></v-checkbox>
                                                        </v-col>
                                                        <v-col>
                                                            <v-select label="Genişlik" v-model="selectedField.cols"
                                                                :items="colsOptions" item-text="text" item-value="value"
                                                                dense></v-select>
                                                        </v-col>
                                                        <v-col>
                                                            <v-checkbox v-model="selectedField.identity"
                                                                label="Benzersiz cevap iste"></v-checkbox>
                                                        </v-col>
                                                    </v-row>







                                                    <v-expansion-panels>
                                                        <v-expansion-panel>
                                                            <v-expansion-panel-header>
                                                                Dinamik Koşul Oluşturucu
                                                            </v-expansion-panel-header>
                                                            <v-expansion-panel-content>
                                                                <ConditionBuilder
                                                                    :fields="seciliItemHaricDigerItemlar()"
                                                                    v-model="selectedField.visibleIf" />
                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                </v-form>



                                            </v-card-text>
                                        </v-card>
                                        <v-card color="basil" v-if="selectedField.type === 'check'" flat>
                                            <v-card-text>

                                                <v-container>
                                                    <v-row>
                                                        <v-col>
                                                            <v-text-field label="Etiket"
                                                                v-model="selectedField.label"></v-text-field>
                                                        </v-col>
                                                        <v-col>
                                                            <v-text-field label="Kısa Açıklama"
                                                                v-model="selectedField.hint"></v-text-field>
                                                        </v-col>
                                                    </v-row>

                                                    <v-row>
                                                        <v-col>
                                                            <v-checkbox v-model="selectedField.required" label="Gerekli"
                                                                @change="check($event)"></v-checkbox>
                                                        </v-col>
                                                        <v-col>
                                                            <v-text-field label="Grup Adı"
                                                                v-model="selectedField.grpName"></v-text-field>
                                                        </v-col>
                                                        <v-col>
                                                            <v-checkbox v-model="selectedField.identity"
                                                                label="Benzersiz cevap iste"></v-checkbox>
                                                        </v-col>
                                                    </v-row>




                                                    <!-- <v-checkbox v-model="selectedField.multi" label="Çoklu Seçim"
                                                        @change="multiSelectChange($event)"></v-checkbox> -->



                                                    <v-select label="Kolon" v-model="selectedField.cols"
                                                        :items="colsOptions" item-text="text" item-value="value"
                                                        dense></v-select>
                                                    <v-select label="İç Kolon sayısı" v-model="selectedField.incols"
                                                        :items="colsOptions" item-text="text" item-value="value"
                                                        dense></v-select>


                                                    <v-expansion-panels class="my-2">
                                                        <v-expansion-panel>
                                                            <v-expansion-panel-header>
                                                                Seçenekler
                                                            </v-expansion-panel-header>
                                                            <v-expansion-panel-content>
                                                                <v-card elevation="2">
                                                                    <!-- v-if="selectedField.multiItemShow" -->
                                                                    <!-- <v-list-item three-line>
                                                                        <v-list-item-content>
                                                                            <div class="text-overline mb-4">
                                                                                Seçenekler Ekle(Her satıra bir tane)
                                                                            </div>
                                                                            <v-list-item-title class="text-h5 mb-1">
                                                                                <v-textarea ref="taSecenekler"
                                                                                    v-model="itemSumList"
                                                                                    label="Seçenekler"></v-textarea>
                                                                            </v-list-item-title>

                                                                        </v-list-item-content>

                                                                        <v-card-actions>
                                                                            <v-btn outlined @click="seceneklerRadioEkle"
                                                                                center text>
                                                                                Ekle
                                                                            </v-btn>
                                                                        </v-card-actions>
                                                                    </v-list-item> -->
                                                                    <v-toolbar color="indigo" dark>


                                                                        <v-toolbar-title>Seçenekler</v-toolbar-title>

                                                                        <v-spacer></v-spacer>
                                                                        <v-tooltip bottom>
                                                                            <template v-slot:activator="{ on, attrs }">

                                                                                <v-btn icon @click="itemSelectClick"
                                                                                    v-bind="attrs" dark v-on="on">
                                                                                    <v-icon>mdi-location-enter</v-icon>
                                                                                </v-btn>


                                                                            </template>
                                                                            <span>Hızlı Giriş</span>
                                                                        </v-tooltip>

                                                                    </v-toolbar>
                                                                    <v-card-text>
                                                                        <v-simple-table height="250px">
                                                                            <template v-slot:default>
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th class="text-left">
                                                                                            İsim
                                                                                        </th>
                                                                                        <th colspan="2"
                                                                                            class="text-left">
                                                                                            <v-checkbox
                                                                                                v-model="selectedField.multiItemShow"
                                                                                                label="Hızlı Giriş"></v-checkbox>
                                                                                        </th>

                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr v-for="(item, i) in selectedField.items"
                                                                                        :key="i">
                                                                                        <td> <v-text-field clearable
                                                                                                @input="inputItem(item, i, target)"
                                                                                                v-model="item.name"></v-text-field>
                                                                                        </td>
                                                                                        <td width="50px">
                                                                                            <v-btn icon>
                                                                                                <v-icon
                                                                                                    color="grey lighten-1"
                                                                                                    @click="addSelectItem(item, i)">mdi-plus</v-icon>
                                                                                            </v-btn>
                                                                                        </td>
                                                                                        <td width="50px">

                                                                                            <v-btn icon>
                                                                                                <v-icon
                                                                                                    color="grey lighten-1"
                                                                                                    @click="deleteSelectItem(item, i)">mdi-delete</v-icon>
                                                                                            </v-btn>
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </template>
                                                                        </v-simple-table>
                                                                    </v-card-text>
                                                                </v-card>



                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>

                                                    <v-expansion-panels>
                                                        <v-expansion-panel>
                                                            <v-expansion-panel-header>
                                                                Dinamik Koşul Oluşturucu
                                                            </v-expansion-panel-header>
                                                            <v-expansion-panel-content>
                                                                <ConditionBuilder
                                                                    :fields="seciliItemHaricDigerItemlar()"
                                                                    v-model="selectedField.visibleIf" />
                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>




                                                </v-container>



                                            </v-card-text>
                                        </v-card>
                                        <v-card color="basil" v-if="selectedField.type === 'html'" flat>
                                            <v-card-text>

                                                <v-container>
                                                    <quill-editor v-model="selectedField.html" :options="editorOptions"
                                                        style="min-height: 200px" />
                                                    <v-text-field label="Grup Adı"
                                                        v-model="selectedField.grpName"></v-text-field>
                                                    <h2>Taban Rengi</h2>


                                                    <v-container>
                                                        <v-row>
                                                            <v-col cols="6">

                                                                <v-checkbox v-model="selectedField.borderrenk.istek"
                                                                    label="Çerçeve Rengi Koy"></v-checkbox>
                                                                <v-color-picker v-if="selectedField.borderrenk.istek"
                                                                    v-model="selectedField.borderrenk.value"
                                                                    class="ma-2" hide-canvas></v-color-picker>
                                                            </v-col>
                                                            <v-col cols="6">
                                                                <v-checkbox v-model="selectedField.tabanrenk.istek"
                                                                    label="Taban Rengi Koy"></v-checkbox>
                                                                <v-color-picker v-if="selectedField.tabanrenk.istek"
                                                                    v-model="selectedField.tabanrenk.value" class="ma-2"
                                                                    hide-canvas></v-color-picker>
                                                            </v-col>
                                                        </v-row>
                                                        <v-expansion-panels>
                                                            <v-expansion-panel>
                                                                <v-expansion-panel-header>
                                                                    Dinamik Koşul Oluşturucu
                                                                </v-expansion-panel-header>
                                                                <v-expansion-panel-content>
                                                                    <ConditionBuilder
                                                                        :fields="seciliItemHaricDigerItemlar()"
                                                                        v-model="selectedField.visibleIf" />
                                                                </v-expansion-panel-content>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                    </v-container>








                                                </v-container>



                                            </v-card-text>
                                        </v-card>
                                        <v-card color="basil" v-if="selectedField.type === 'file'" flat>
                                            <v-card-text>

                                                <v-form ref="form" v-model="valid" lazy-validation>
                                                    <v-row>
                                                        <v-col>
                                                            <v-text-field label="Etiket"
                                                                v-model="selectedField.label"></v-text-field>
                                                        </v-col>
                                                        <v-col>
                                                            <v-text-field label="Dosya Büyüklük"
                                                                v-model.number="selectedField.size"
                                                                suffix=" MB"></v-text-field>
                                                        </v-col>
                                                        <v-col>
                                                            <v-text-field label="Kısa Açıklama"
                                                                v-model="selectedField.hint"></v-text-field>
                                                        </v-col>
                                                    </v-row>






                                                    <v-select label="Dosya Tipi" v-model="selectedField.accept" multiple
                                                        :items="fileTypes" item-text="name" item-value="id"
                                                        dense></v-select>

                                                    <v-row>
                                                        <v-col cols="6">
                                                            <v-checkbox v-model="selectedField.required" label="Gerekli"
                                                                @change="check($event)"></v-checkbox>
                                                        </v-col>
                                                        <v-col cols="6">
                                                            <v-checkbox v-model="selectedField.multi"
                                                                label="Çoklu Dosya Yükleme"></v-checkbox>
                                                        </v-col>
                                                    </v-row>



                                                    <v-row>
                                                        <v-col> <v-text-field label="Grup Adı"
                                                                v-model="selectedField.grpName"></v-text-field></v-col>
                                                        <v-col><v-select label="Genişlik" v-model="selectedField.cols"
                                                                :items="colsOptions" item-text="text" item-value="value"
                                                                dense></v-select></v-col>
                                                    </v-row>




                                                    <v-expansion-panels>
                                                        <v-expansion-panel>
                                                            <v-expansion-panel-header>
                                                                Dinamik Koşul Oluşturucu
                                                            </v-expansion-panel-header>
                                                            <v-expansion-panel-content>
                                                                <ConditionBuilder
                                                                    :fields="seciliItemHaricDigerItemlar()"
                                                                    v-model="selectedField.visibleIf" />
                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                </v-form>



                                            </v-card-text>
                                        </v-card>

                                        <v-card color="basil" v-if="selectedField.type === 'radioMatrix'" flat>
                                            <v-card-text>
                                                <v-text-field label="Başlık Adı"
                                                    v-model="selectedField.label"></v-text-field>
                                                <v-container>
                                                    <v-row>
                                                        <v-col>
                                                            <h3>Sorular</h3>


                                                            <draggable v-model="selectedField.rows" draggable=".item">



                                                                <v-list-item class="pa-0 item"
                                                                    v-for="(row, index) in selectedField.rows"
                                                                    :key="row.id" dense>
                                                                    <v-list-item-avatar>
                                                                        <v-app-bar-nav-icon></v-app-bar-nav-icon>
                                                                    </v-list-item-avatar>
                                                                    <v-list-item-content class="pa-0"
                                                                        :class="{ 'disabled': row.disable }">
                                                                        <v-text-field dense placeholder="Soru"
                                                                            v-model="row.name"></v-text-field>
                                                                        <span v-if="row.disable"
                                                                            class="overlay">Pasif</span>
                                                                    </v-list-item-content>
                                                                    <v-list-item-icon>

                                                                    </v-list-item-icon>
                                                                    <v-list-item-action>


                                                                        <v-icon v-if="!row.disable"
                                                                            @click="matrixItemDelete(row, index)" small
                                                                            color="red">
                                                                            mdi-close
                                                                        </v-icon>
                                                                        <v-icon v-else
                                                                            @click="matrixItemAktifYap(row, index)"
                                                                            small color="red">
                                                                            mdi-wrap-disabled
                                                                        </v-icon>


                                                                    </v-list-item-action>
                                                                    <!-- <v-list-item-action>


                                                                        <v-icon @click="matrixItemDelete(row, index)"
                                                                            small color="red">
                                                                            mdi-close
                                                                        </v-icon>


                                                                    </v-list-item-action> -->
                                                                </v-list-item>



                                                            </draggable>






                                                            <v-btn
                                                                @click="matrixRowAdd(selectedField.type)">Ekle</v-btn>
                                                        </v-col>
                                                        <v-col>

                                                            <v-row>
                                                                <v-col cols="8">
                                                                    <v-select v-model="selectedField.kolonType"
                                                                        :items="kolontipis" item-text="name"
                                                                        item-value="id" label="Kolon Tipi">

            <template v-slot:prepend>
                 <v-icon @click="crdLikert=true">mdi-help-circle-outline</v-icon>
                   
                                </template>
                                                                    </v-select>
                                                                </v-col>
                                                                <v-col cols="4"
                                                                    v-if="selectedField.kolonType == KolonType.LikertYildiz">
                                                                    <v-select v-model="selectedField.yildizAdet"
                                                                        :items="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"></v-select>
                                                                </v-col>
                                                            </v-row>


                                                            <div
                                                                v-if="selectedField.kolonType != KolonType.LikertYildiz">
                                                                <h3>Seçenekler</h3>
                                                                <draggable v-model="selectedField.columns"
                                                                    draggable=".itemColumn">
                                                                    <v-list-item class="pa-0 itemColumn"
                                                                        v-for="(column, index) in selectedField.columns"
                                                                        :key="index" dense>
                                                                        <!-- <v-list-item-avatar
                                                                            v-if="selectedField.kolonType == 2">
                                                                            <v-app-bar-nav-icon>{{ index + 1
                                                                            }}</v-app-bar-nav-icon>
                                                                        </v-list-item-avatar> -->
                                                                        <v-list-item-content class="pa-0">
                                                                            <v-text-field dense placeholder="Seçenek"
                                                                                v-model="column.name"></v-text-field>

                                                                        </v-list-item-content>
                                                                        <v-list-item-action>


                                                                            <v-icon
                                                                                @click="selectedField.columns.splice(index, 1)"
                                                                                small color="red">
                                                                                mdi-close
                                                                            </v-icon>


                                                                        </v-list-item-action>
                                                                    </v-list-item>

                                                                </draggable>
                                                                <v-btn @click="matrixColumnAdd">Ekle</v-btn>
                                                            </div>







                                                        </v-col>
                                                    </v-row>

                                                    <v-row>
                                                        <v-col>
                                                            <v-checkbox v-model="selectedField.required" label="Gerekli"
                                                                @change="check($event)"></v-checkbox>
                                                        </v-col>
                                                        <v-col>
                                                            <v-text-field label="Grup Adı"
                                                                v-model="selectedField.grpName"></v-text-field>
                                                        </v-col>
                                                        <v-col>
                                                            <v-select label="Genişlik" v-model="selectedField.cols"
                                                                :items="colsOptions" item-text="text" item-value="value"
                                                                dense></v-select>
                                                        </v-col>
                                                    </v-row>
                                                    <v-expansion-panels>
                                                        <v-expansion-panel>
                                                            <v-expansion-panel-header>
                                                                Dinamik Koşul Oluşturucu
                                                            </v-expansion-panel-header>
                                                            <v-expansion-panel-content>
                                                                <ConditionBuilder
                                                                    :fields="seciliItemHaricDigerItemlar()"
                                                                    v-model="selectedField.visibleIf" />
                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>




                                                </v-container>



                                            </v-card-text>
                                        </v-card>
                                        <v-card color="basil" v-if="selectedField.type === 'checkMatrix'" flat>
                                            <v-card-text>
                                                <v-text-field label="Başlık Adı"
                                                    v-model="selectedField.label"></v-text-field>
                                                <v-container>
                                                    <v-row>
                                                        <v-col>
                                                            <h3>Sorular</h3>


                                                            <draggable v-model="selectedField.rows" draggable=".item">



                                                                <v-list-item class="pa-0 item"
                                                                    v-for="(row, index) in selectedField.rows"
                                                                    :key="row.id" dense>
                                                                    <v-list-item-avatar>
                                                                        <v-app-bar-nav-icon></v-app-bar-nav-icon>
                                                                    </v-list-item-avatar>
                                                                    <v-list-item-content class="pa-0"
                                                                        :class="{ 'disabled': row.disable }">
                                                                        <v-text-field dense placeholder="Soru"
                                                                            v-model="row.name"></v-text-field>
                                                                        <span v-if="row.disable"
                                                                            class="overlay">Pasif</span>

                                                                    </v-list-item-content>
                                                                    <!-- <v-list-item-icon>
{{ row.disable ? 'P':'A' }}
                                                                    </v-list-item-icon> -->
                                                                    <v-list-item-action>


                                                                        <v-icon v-if="!row.disable"
                                                                            @click="matrixItemDelete(row, index)" small
                                                                            color="red">
                                                                            mdi-close
                                                                        </v-icon>
                                                                        <v-icon v-else
                                                                            @click="matrixItemAktifYap(row, index)"
                                                                            small color="red">
                                                                            mdi-wrap-disabled
                                                                        </v-icon>


                                                                    </v-list-item-action>
                                                                </v-list-item>



                                                            </draggable>






                                                            <v-btn
                                                                @click="matrixRowAdd(selectedField.type)">Ekle</v-btn>
                                                        </v-col>
                                                        <v-col>

                                                            <h3>Seçenekler</h3>
                                                            <draggable v-model="selectedField.columns"
                                                                draggable=".itemColumn">
                                                                <v-list-item class="pa-0 itemColumn"
                                                                    v-for="(column, index) in selectedField.columns"
                                                                    :key="index" dense>
                                                                    <v-list-item-avatar>
                                                                        <v-app-bar-nav-icon></v-app-bar-nav-icon>
                                                                    </v-list-item-avatar>
                                                                    <v-list-item-content class="pa-0">
                                                                        <v-text-field dense placeholder="Seçenek"
                                                                            v-model="column.name"></v-text-field>
                                                                    </v-list-item-content>
                                                                    <v-list-item-action>


                                                                        <v-icon
                                                                            @click="selectedField.columns.splice(index, 1)"
                                                                            small color="red">
                                                                            mdi-close
                                                                        </v-icon>


                                                                    </v-list-item-action>
                                                                </v-list-item>

                                                            </draggable>





                                                            <v-btn @click="matrixColumnAdd">Ekle</v-btn>
                                                        </v-col>
                                                    </v-row>

                                                    <v-row>
                                                        <v-col>
                                                            <v-checkbox v-model="selectedField.required" label="Gerekli"
                                                                @change="check($event)"></v-checkbox>
                                                        </v-col>
                                                        <v-col>
                                                            <v-text-field label="Grup Adı"
                                                                v-model="selectedField.grpName"></v-text-field>
                                                        </v-col>
                                                        <v-col>
                                                            <v-select label="Genişlik" v-model="selectedField.cols"
                                                                :items="colsOptions" item-text="text" item-value="value"
                                                                dense></v-select>
                                                        </v-col>
                                                    </v-row>
                                                    <v-expansion-panels>
                                                        <v-expansion-panel>
                                                            <v-expansion-panel-header>
                                                                Dinamik Koşul Oluşturucu
                                                            </v-expansion-panel-header>
                                                            <v-expansion-panel-content>
                                                                <ConditionBuilder
                                                                    :fields="seciliItemHaricDigerItemlar()"
                                                                    v-model="selectedField.visibleIf" />
                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>




                                                </v-container>



                                            </v-card-text>
                                        </v-card>
                                        <v-card color="basil" v-if="selectedField.type === 'textMatrix'" flat>
                                            <v-card-text>
                                                <v-text-field label="Başlık Adı"
                                                    v-model="selectedField.label"></v-text-field>
                                                <v-text-field label="Açıklama"
                                                    v-model="selectedField.subLabel"></v-text-field>

                                                <v-container>
                                                    <v-row>
                                                        <v-col>
                                                            <h3>Sorular</h3>


                                                            <draggable v-model="selectedField.rows" draggable=".item">



                                                                <v-list-item class="pa-0 item"
                                                                    v-for="(row, index) in selectedField.rows"
                                                                    :key="row.id" dense>
                                                                    <v-list-item-avatar>
                                                                        <v-app-bar-nav-icon></v-app-bar-nav-icon>
                                                                    </v-list-item-avatar>
                                                                    <v-list-item-content class="pa-0">
                                                                        <v-text-field dense placeholder="Soru"
                                                                            v-model="row.name"></v-text-field>
                                                                    </v-list-item-content>
                                                                    <v-list-item-icon>

                                                                    </v-list-item-icon>
                                                                    <v-list-item-action>


                                                                        <v-icon @click="matrixTextRowDelete(row, index)"
                                                                            small color="red">
                                                                            mdi-close
                                                                        </v-icon>


                                                                    </v-list-item-action>
                                                                </v-list-item>



                                                            </draggable>






                                                            <v-btn @click="matrixTextRowAdd">Ekle</v-btn>
                                                        </v-col>
                                                        <v-col>

                                                            <h3>Seçenekler</h3>
                                                            <draggable v-model="selectedField.columns"
                                                                draggable=".itemColumn">
                                                                <v-list-item class="pa-0 itemColumn"
                                                                    v-for="(column, index) in selectedField.columns"
                                                                    :key="index" dense>
                                                                    <v-list-item-avatar>
                                                                        <v-app-bar-nav-icon></v-app-bar-nav-icon>
                                                                    </v-list-item-avatar>
                                                                    <v-list-item-content class="pa-0">
                                                                        <v-text-field dense placeholder="Seçenek"
                                                                            v-model="column.name"></v-text-field>
                                                                    </v-list-item-content>
                                                                    <v-list-item-action>


                                                                        <v-icon
                                                                            @click="matrixTextColumnDelete(column, index)"
                                                                            small color="red">
                                                                            mdi-close
                                                                        </v-icon>


                                                                    </v-list-item-action>
                                                                </v-list-item>

                                                            </draggable>




                                                            <v-select :items="textItems" item-text="name"
                                                                item-value="id" v-model="textItemsSelected"
                                                                label="Tür"></v-select>
                                                            <v-btn @click="matrixTextColumAdd">Ekle</v-btn>
                                                        </v-col>
                                                    </v-row>

                                                    <v-row>
                                                        <v-col>
                                                            <v-checkbox v-model="selectedField.required" label="Gerekli"
                                                                @change="check($event)"></v-checkbox>
                                                        </v-col>
                                                        <v-col>
                                                            <v-text-field label="Grup Adı"
                                                                v-model="selectedField.grpName"></v-text-field>
                                                        </v-col>


                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="8">
                                                            <v-checkbox v-model="selectedField.dynamicRowAddAllow"
                                                                label="Kullanıcı Satır ekleyebilsin"></v-checkbox>



                                                        </v-col>
                                                        <v-col v-if="selectedField.dynamicRowAddAllow">
                                                            <v-text-field label="Min"
                                                                v-model="selectedField.minRowCount"></v-text-field>
                                                        </v-col>
                                                        <v-col v-if="selectedField.dynamicRowAddAllow">
                                                            <v-text-field label="Max"
                                                                v-model="selectedField.maxRowCount"></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                    <v-expansion-panels>
                                                        <v-expansion-panel>
                                                            <v-expansion-panel-header>
                                                                Dinamik Koşul Oluşturucu
                                                            </v-expansion-panel-header>
                                                            <v-expansion-panel-content>
                                                                <ConditionBuilder
                                                                    :fields="seciliItemHaricDigerItemlar()"
                                                                    v-model="selectedField.visibleIf" />
                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>




                                                </v-container>



                                            </v-card-text>
                                        </v-card>
                                    </v-tab-item>


                                </v-tabs>

                            </v-container>




                        </v-col>
                    </v-row>


                </v-form>
            </v-card-text>

            <v-divider></v-divider>

            <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            I accept
          </v-btn>
        </v-card-actions> -->
        </v-card>




        <v-snackbar v-model="snackbar" timeout="2000">
            Lütfen istenilen formarda veri girişi yapınız

            <template v-slot:action="{ attrs }">
                <v-btn color="blue" text v-bind="attrs" :click="snackbar = false">
                    Kapat
                </v-btn>
            </template>
        </v-snackbar>

    </div>

</template>

<script>

import { rules } from '@/plugins/custom.js'
import { numberSF, textSF, radioSF, selectSF, dateSF, mailSF, checkSF, htmlSF, fileSF, checkMatrixSF, radioMatrixSF, textMatrixSF, dateHtmlSF } from '@/plugins/FieldDataFormat.js'
import draggable from 'vuedraggable'
import VText from '@/components/field_types/VText.vue';
import VNumber from '@/components/field_types/VNumber.vue';
import VRadio from '@/components/field_types/VRadio.vue';
import VSelect from '@/components/field_types/VSelect.vue';
import VDate from '@/components/field_types/VDate.vue';
import VCustomDate from '@/components/CustomDatePicker.vue';
import VMail from '@/components/field_types/VMail.vue';
import VCheck from '@/components/field_types/VCheck.vue';
import VHtmlEditor from '@/components/field_types/VHtmlEditor.vue';
import FormOgeService from '@/services/FormOgeService';
import FormService from '@/services/FormService';
import router from '@/router';
import VFile from '@/components/field_types/VFile.vue';
import { FileExtensions, FileTypes } from '@/plugins/FileExtensions.js'
import ConditionBuilder from "@/components/ConditionBuilder.vue";
import MaskHelp from "@/components/MaskHelp.vue";
import VCheckMatrix from '@/components/field_types/VCheckMatrix.vue';
import VRadioMatrix from '@/components/field_types/VRadioMatrix.vue';
import VTextMatrix from '@/components/field_types/VTextMatrix.vue';
import VDateHtml from '@/components/field_types/VDateHtml.vue';
import FilterCheckSelect from '../components/FilterCheckSelect.vue';
import { KolonType, ValueTurEnum } from '@/plugins/Enum.js';
//import router from '@/router';


/* eslint-disable no-unused-vars */
export default {
    components: {
        draggable, VText, VNumber, VRadio, VSelect, VDate, VMail, VCheck, VHtmlEditor, VFile, VCustomDate, ConditionBuilder, MaskHelp, VCheckMatrix, VRadioMatrix, VTextMatrix, VDateHtml
        , FilterCheckSelect
    },
    name: 'HelloWorld',

    data: () => ({

        ozellikDizini: { numberSF, textSF, radioSF, selectSF, dateSF, mailSF, checkSF, htmlSF, fileSF, checkMatrixSF, radioMatrixSF, textMatrixSF, dateHtmlSF },
        KolonType: KolonType,
        allowDgItemSelect: false,
        dgMask: false,
        crdLikert:false,
        dateTypes: [
            { id: "date", name: "Tarih" },
            { id: "time", name: "Zaman" },
            { id: "datetime-local", name: "Tarih ve Zaman" },

        ],

        kolontipis: [
            { id: 1, name: "Dinamik Kolon" },
          //  { id: 2, name: "Dinamik Likert" },
            { id: 3, name: "Likert Yıldız" }
        ],
        textItems: [
            { id: "text", name: "Metin" },
            { id: "tarih", name: "Tarih" },
            { id: "number", name: "Sayı" },
            { id: "select", name: "Efekt Açılır Menü" },
            { id: "posta", name: "E-Posta " },
        ],
        textItemsSelected: null,
        visibleIf: {
            logic: "AND",
            conditions: []
        },
        fileTypes: FileTypes,
        acceptList: [
            { id: 'image/*', name: 'Fotoğraflar' },
            { id: '.pdf', name: 'Pdf Dosyaları' },
            { id: 'doc,docx', name: 'Word' },
            { id: '.xls,xlsx', name: 'Excel' },
        ],
        content: '<p>Merhaba <strong>Tasarım Alanı</strong></p>',
        editorOptions: {
            theme: 'snow',
            placeholder: 'İçeriği buraya yazın...',
            modules: {
                toolbar: [
                    [{ header: [1, 2, 3, 4, 5, 6, false] }],
                    [{ align: [] }],
                    ['bold', 'italic', 'underline'],
                    [{ color: [] }, { background: [] }],

                    [{ list: 'ordered' }, { list: 'bullet' }],
                    [{ direction: 'rtl' }],
                    ['link', 'video', 'image'],
                    ['clean']
                ]
            }
        },
        metinAyar: textSF,

        valid: false,
        snackbar: false,
        denemeValue: 'sdfsdf',
        itemSumList: "",
        itemSumPlaceHolder: "",
        fields: [


        ],

        items: ['Sales', 'Marketing', 'Finance'],
        selectedField: { type: 'old' },
        tab: 2,
        required: eval(" value => !!value || 'Required.'"),
        validCommands: [eval(" value => !!value || 'Required.'"), eval(" value => value.length <= 20 || 'Max 20 characters'")],
        validCommandList: [{ id: 1, label: 'Boş Geçilemez', value: " value => !!value || 'Required.'", message: 'Bu alana boş bırakılamaz' }
        ],

        selectedValidCommandList: [],
        itemTypeList: [
            textSF,
            numberSF,
            radioSF,
            selectSF,
            //dateSF,
            dateHtmlSF,
            mailSF,
            checkSF,
            fileSF,
            htmlSF,
            checkMatrixSF,
            radioMatrixSF,
            textMatrixSF,



        ],
        colsOptions: [
            { text: "Tam Genişlik", value: 12 },
            { text: "Yarım", value: 6 },
            { text: "Üçte Bir", value: 4 }
        ]

    }),
    computed: {


        getValidlist() {

            return this.validCommandList.filter(m => this.selectedValidCommandList.some(x => x == m.id)).map(m => eval(m.value))
        },
        myList: {
            get() {
                return this.fields
            },
            set(value) {
                //  this.fields.push(value)
            }
        },
        getTriggerSumDataFormat() {
            //&#10;
            // return this.selectedField.trigger ? 'Sinop&-&Boyabat  \nSinop&-&Erfelek \nKaraman&-&Kazım Karabekir  ' : 'Kırmızı  \nYeşil \nMavi   '
            return this.selectedField.trigger ? 'Sinop::Boyabat  \nSinop::Erfelek \nKaraman::Kazım Karabekir  ' : 'Kırmızı  \nYeşil \nMavi   '
        }
    },
    created() {
        // console.log("created",KolonType.LikertYildiz);
        this.databind()
    },
    watch: {

        // selectedField: {
        //     immediate: true,
        //     handler() {

        //     },
        //     deep: true
        // }
    },
    methods: {
        filterSecilenler(v) {


            if (this.selectedField.type == 'select') {
                this.selectedField.store = v.map((m) => {
                    return {
                        id: m,
                        name: m
                    };
                });
            }
            else {
                this.selectedField.items = v.map((m) => {
                    return {
                        id: m,
                        name: m
                    };
                });
            }



            this.allowDgItemSelect = false;
        },
        itemSelectClick() {
            this.allowDgItemSelect = true;
            if (this.selectedField.type == 'select') {
                if (this.selectedField.store) {
                    this.$refs.slcItem.setSelected(this.selectedField.store.map(m => m.name));

                }
                else {
                    this.$refs.slcItem.setSelected([]);

                }
            }
            else {
                if (this.selectedField.items) {
                    this.$refs.slcItem.setSelected(this.selectedField.items.map(m => m.name));

                }
                else {
                    this.$refs.slcItem.setSelected([]);

                }
            }


        },
        setClickChange(json) {
            console.log("setClickChange", json);
            this.selectedField = json;
        },
        matrixItemDelete(item, index) {

            FormOgeService.isDeleteValid(item.id).then((result) => {
                if (!result.data.isFormOgeVarMi) {
                    if (confirm(`Bu alanı silmek istediğinize emin misiniz`)) {
                        this.selectedField.rows.splice(index, 1);
                        this.$toast.success("Başarılı bir şekilde silinmiştir.");
                    }

                }
                else {
                    if (!result.data.isFormOgeSavedesVarMi) {
                        if (confirm(`Bu alanı silmek istediğinize emin misiniz`)) {
                            FormOgeService.matrixItemsDelete(item.id).then((result) => {

                                this.selectedField.rows.splice(index, 1);
                                this.$toast.success("Başarılı bir şekilde silinmiştir.");
                            }).catch((err) => {

                            });
                        }

                    }
                    else {
                        let uyari = !item.disable ? 'Bu alana ait veri girişi bulunmaktadır.Bu alan silinemez.' : '';
                        if (confirm(`${uyari} ${item.disable ? 'Aktif' : 'Pasif'} yapmak  istediğinize emin misiniz?`)) {
                            FormOgeService.matrixItemsDelete(item.id).then((result) => {

                                item.disable = !item.disable;
                                this.$toast.success("Başarılı bir şekilde pasif edilmiştir.");
                            }).catch((err) => {

                            });

                        }
                    }
                }
            }).catch((err) => {

            });




        },
        matrixItemAktifYap(item, index) {
            FormOgeService.matrixItemAktifYap(item.id).then((result) => {

                item.disable = false;


                // 
            }).catch((err) => {

            });
        },
        matrixTextRowDelete(item, index) {


            this.selectedField.rows.splice(index, 1);


        },
        matrixTextColumnDelete(item, index) {

            this.selectedField.rows.forEach(element => {
                delete element.values[item.id];
            });
            this.selectedField.columns.splice(index, 1);


        },

        matrixColumnAdd() {
            FormOgeService.newGuid().then((result) => {
                this.selectedField.columns.push({ id: result.data, name: "" });

            }).catch((err) => {
                this.$toast.error("Kolon ekleme sırasında hata oluşmaktadır.");

            });

        },
        matrixRowAdd(tip) {
            FormOgeService.newGuid().then((result) => {
                if (tip === "checkMatrix") {
                    this.selectedField.rows.push({ id: result.data, name: "", value: [], disable: false })
                }
                else {
                    this.selectedField.rows.push({ id: result.data, name: "", value: "", disable: false })
                }
            }).catch((err) => {
                this.$toast.error("Soru ekleme işleminde hata oluşmaktadır.");

            });

        },
        matrixTextColumAdd() {
            FormOgeService.newGuid().then((result) => {
                let sf = null;
                if (!this.textItemsSelected) {
                    this.$toast.warning("Lütfen Tür Seçiniz.");
                    return false;
                }


                switch (this.textItemsSelected) {
                    case "text":
                        sf = textSF
                        break;
                    case "number":
                        sf = numberSF;
                        break;
                    case "select":
                        sf = selectSF;
                        break;
                    case "tarih":
                        sf = dateHtmlSF;
                        break;
                    case "posta":
                        sf = mailSF;
                        break;
                    default:
                    // code block
                }

                // console.log("textSf:", result.data, sf);
                // console.log("this.selectedField:", this.selectedField);





                this.selectedField.columns.push({ id: result.data, json: structuredClone(sf), })
                this.selectedField.rows.forEach(row => {


                    this.selectedField.columns.forEach(elementColumn => {
                        if (!Object.prototype.hasOwnProperty.call(row.values, elementColumn.id)) {
                            row.values[elementColumn.id] = "";
                        }

                    });


                });

            }).catch((err) => {
                this.$toast.error("Kopyalama işleminde hata oluşmaktadır.");

            });

        },
        matrixTextRowAdd() {



            FormOgeService.newGuid().then((result) => {
                let value = {}
                this.selectedField.columns.forEach(element => {
                    value[element.id] = "";

                });
                this.selectedField.rows.forEach(row => {

                    this.selectedField.columns.forEach(elementColumn => {
                        if (!Object.prototype.hasOwnProperty.call(row.values, elementColumn.id)) {
                            row.values[elementColumn.id] = "";
                        }

                    });


                });
                this.selectedField.rows.push({ id: result.data, name: "", values: value, })

            }).catch((err) => {
                this.$toast.error("Kopyalama işleminde hata oluşmaktadır.");

            });

        },

        // matrixCheckRowAdd() {
        //     FormOgeService.newGuid().then((result) => {
        //         this.selectedField.rows.push({ id: result.data, name: "", value: [], disable: false })

        //     }).catch((err) => {
        //         this.$toast.error("Kopyalama işleminde hata oluşmaktadır.");

        //     });

        // },
        databind() {
            //  console.log("databind",this.$route);
            let this2 = this;

            FormService.listFormItemsAdmin(this.$route.params.id).then(function (response) {
                // console.log("DAta bind:",response.data);
                let tempFields = response.data.map(m => { let value = JSON.parse(m); value.value = ""; return value });

                tempFields.forEach(obj => {

                    if (!Object.prototype.hasOwnProperty.call(obj, "visibleIf")) {
                        obj.visibleIf = { goster: "goster", logic: "AND", conditions: [] };
                    }

                });
                this2.fields = tempFields;
                console.log("Items:", this2.fields);
                //  this.items=JSON.parse(response.data);
                //vm.users = response.data
            }).catch((err) => {
                this.$toast.success(err.response.data.label);
                router.push({ name: 'formlar' })
            });
        },
        triggerEvent(e) {
            //console.log("triggerEvent Parameter", e.id);
            let triggeredItem = this.fields.find(m => m.id == e.id);
            //  console.log("triggerEvent triggeredItem", triggeredItem);
            triggeredItem.store = [...e.values];
        },

        check: function (e) {


            if (e) {
                if (!this.selectedField.rules.includes(rules.required.name)) {
                    this.selectedField.rules = [...this.selectedField.rules, rules.required.name];
                }
            }
            else {
                this.selectedField.rules = [...this.selectedField.rules.filter(r => r !== rules.required.name)];
            }
        },

        validate() {

            let selectedItems = this.fields.map((element, index) => {

                return { id: element.id, name: element.label, type: element.type, json: JSON.stringify(element), sira: index, disable: element.disable }
            }

            );
            let matrixCheckList = this.fields.filter(m => m.type == "checkMatrix");
            let matrixRadioList = this.fields.filter(m => m.type == "radioMatrix");
            let matrixList = [];
            matrixCheckList.forEach(element => {
                element.rows.forEach((elementRow, index) => {
                    const clone = JSON.parse(JSON.stringify(element));
                    clone.id = elementRow.id;
                    clone.parentId = element.id;
                    let row = { id: elementRow.id, name: elementRow.name, type: "matrixRow", json: JSON.stringify(clone), sira: index, disable: element.disable }
                    matrixList.push(row);
                });

            });
            matrixRadioList.forEach(element => {
                element.rows.forEach((elementRow, index) => {
                    const clone = JSON.parse(JSON.stringify(element));
                    clone.id = elementRow.id;
                    clone.parentId = element.id;
                    let row = { id: elementRow.id, name: elementRow.name, type: "matrixRow", json: JSON.stringify(clone), sira: index, disable: element.disable }
                    matrixList.push(row);
                });

            });

            selectedItems = [...selectedItems, ...matrixList];




            console.log("Form Validate:", selectedItems);
            console.log("Matrix:", matrixList);

            FormService.ItemsAdd(this.$route.params.id, selectedItems).then((result) => {
                this.$toast.success("Başarılı bir şekilde kaydedilmiştir.");
                this.databind();
            }).catch((err) => {
                this.$toast.warning("Hata Oluştu.")
            });




        },
        seceneklerEkle(item) {
            let items = this.itemSumList.split("\n"); //this.$refs.taSecenekler.split("\n");
            if (!this.selectedField.trigger) {

                items.forEach(m => {
                    this.selectedField.store.push(({ id: m, name: m }));

                })

                this.itemSumList = "";
                this.selectedField.multiItemShow = false;

            }
            else {

                if (this.itemSumList.every(m => m.contains("::"))) {
                    items.forEach(m => {
                        this.selectedField.store.push(({ id: m, name: m }));

                    })

                    this.itemSumList = "";
                    this.selectedField.multiItemShow = false;
                }
                else {
                    alert("Tetiklemeli olması için tün verilerin istenilen formatda olması gerekmektedir.")
                }
            }
        },
        seceneklerRadioEkle(item) {
            let items = this.itemSumList.split("\n"); //this.$refs.taSecenekler.split("\n");
            let addItems = items.map(x => { return { id: x, name: x } })

            this.selectedField.items.push(...addItems);


        },

        inputItem(item, index, target) {
            // this.selectedField.$set(index, Object.assign({}, item))
            //  this.$set(this.selectedField.items2, index, Object.assign({}, item))
            console.log("inputItem", item, target)
            item.id = item.name;

        },
        addSelectItem(item, index) {
            this.selectedField.items.splice(index + 1, 0, { id: "", name: "" });
        },
        deleteSelectItem(items, index) {
            console.log("deleteSelectItem", this.selectedField.items);
            this.selectedField.items.splice(index, 1);
        },
        addSelectItem2(item, index) {
            this.selectedField.store.splice(index + 1, 0, { id: "", name: "" });
        },
        deleteSelectItem2(items, index) {
            console.log("deleteSelectItem", this.selectedField.store);
            this.selectedField.store.splice(index, 1);
        },
        copyField(item, index) {
            console.log("Item:", item);
            if (confirm("Kopyalama yapmak istediğinize emin misiniz?")) {
                FormOgeService.newGuid().then((result) => {
                    let cloneItem = JSON.parse(JSON.stringify(item));

                    cloneItem.id = result.data;
                    cloneItem.label = cloneItem.label + " (Kopya)";
                    /*Check ve Radio Matrix Kopyalama işlemi*/
                    if (cloneItem.type == "checkMatrix" || cloneItem.type == "radioMatrix") {
                        cloneItem.rows.forEach(row => {
                            FormOgeService.newGuid().then((result2) => { row.id = result2.data });
                        });
                    }
                    /*Check ve Radio Matrix Kopyalama işlemi Sonu*/
                    this.fields.splice(index + 1, 0, cloneItem);
                }).catch((err) => {
                    this.$toast.error("Kopyalama işleminde hata oluşmaktadır.");

                });
            }




        },

        deleteField(item, index) {

            FormOgeService.isDeleteValid(item.id).then((result) => {
                if (!result.data.isFormOgeVarMi) {
                    if (confirm(`Bu alanı silmek istediğinize emin misiniz`)) {
                        this.fields.splice(index, 1);
                        this.$toast.success("Başarılı bir şekilde silinmiştir.");
                    }

                }
                else {
                    if (!result.data.isFormOgeSavedesVarMi) {
                        if (confirm(`Bu alanı silmek istediğinize emin misiniz`)) {
                            FormOgeService.delete(item.id).then((result) => {

                                this.fields.splice(index, 1);
                                this.$toast.success("Başarılı bir şekilde silinmiştir.");
                            }).catch((err) => {

                            });
                        }

                    }
                    else {
                        let uyari = !item.disable ? 'Bu alana ait veri girişi bulunmaktadır.Bu alan silinemez.' : '';
                        if (confirm(`${uyari} ${item.disable ? 'Aktif' : 'Pasif'} yapmak  istediğinize emin misiniz?`)) {
                            // item.disable = !item.disable;
                            FormOgeService.PasifToggle(item.id).then((result) => {
                                //this.fields.splice(index, 1);

                                item.disable = !item.disable;
                                this.$toast.success(`Başarılı bir şekilde ${!item.disable ? 'Aktif' : 'Pasif'} edilmiştir.`);
                            }).catch((err) => {

                            });


                        }
                    }
                }
            }).catch((err) => {

            });




        },
        getFuncValid(list) {

            var requiredList = [];
            if (list.selectedValidCommandList != undefined) {

                requiredList = list.selectedValidCommandList.map(m => eval(m.value))
            }
            if (list.currentValid.length > 0) {

                list.currentValid.forEach(m => {
                    requiredList.push(m);
                })
            }

            if (list.required) {
                requiredList.push(value => !!value || 'Bu alana boş bırakılamaz.');
            }


            return requiredList;

        },
        getFuncValidList(list) {


            var requiredList = [];
            if (list.selectedValidCommandList != undefined) {

                requiredList = list.selectedValidCommandList.map(m => eval(m.value))
            }
            if (list.currentValid.length > 0) {
                //requiredList.concat(list.currentValid);
                list.currentValid.forEach(m => {
                    requiredList.push(m);
                })
            }

            if (list.required) {

                if (list.multi) {
                    requiredList.push(value => value.length > 0 || 'Bu alana boş bırakılamaz.');
                }
                else {
                    requiredList.push(value => !!value || 'Bu alana boş bırakılamaz.');
                }


            }


            return requiredList;

        },
        getcheckboxListValidate(list) {
            //console.log(list);
            // return [v => !!v || '$msg is required'];

            var requiredList = [];

            if (list.currentValid.length > 0) {
                //requiredList.concat(list.currentValid);
                list.currentValid.forEach(m => {
                    requiredList.push(m);
                })
            }

            if (list.required) {

                //|| 'Bu alana boş bırakılamaz.'
                requiredList.push(value => {
                    if (value.length > 0) {
                        list.valid = true;
                        return true
                    }

                    else {
                        list.valid = false;
                        return ''
                    }

                });



            }
            else {
                list.valid = true;
            }


            return requiredList;

        },
        submitForm() {
            // Form submit işlemleri burada yapılabilir
            this.$refs.frmFieldList.validate()

            console.log(this.fields);
        },
        rowEdit(value) {
            this.selectedField = value;
            this.eksikProplariDoldur(this.ozellikDizini[value.type+"SF"],this.selectedField);
           // console.log("selectedField", this.selectedField);
            this.tab = 1;
        },
        eksikProplariDoldur(guncelNesne, dbNesnesi) {
            // Güncel nesnedeki tüm özellikleri dön
            for (const anahtar in guncelNesne) {
                // Eğer veritabanından gelen nesnede bu özellik yoksa, güncel nesnedekini ona ekle
                if (!(anahtar in dbNesnesi)) {
                    this.$set(dbNesnesi, anahtar, guncelNesne[anahtar]);
                    //dbNesnesi[anahtar] = guncelNesne[anahtar];
                }
            }
            return dbNesnesi;
        },
        max(value, item) {
            return value.length <= 2 || 'Max 20 characters'
        },
        checkMove: function (evt) {
            return (evt.draggedContext.element.name !== 'apple');
        },
        finish(item) {
            console.log(item.moved.element) // { id: 1, name: 'Item 1' }
        },
        cloneAction(item, a, b) {
            // console.log("cloned", item);
            return item;
        },
        end1(value) {
            console.log("value degeri", value)
            //[].map(m=>eval(m))
        },
        onChange(event) {

            //  this.fields.splice(event.added.newIndex, 0, event.added.element);


            if (event.added != undefined) {

                FormOgeService.newGuid().then((result) => {
                    let cloneItem = JSON.parse(JSON.stringify(event.added.element));
                    //cloneItem.id = this.newGuid();
                    cloneItem.id = result.data;
                    // if (event.added.element.type == "mail") {
                    //     cloneItem.rules.push(rules.email.name)
                    // }
                    // console.log("cloneItem,cloneItemxxx", cloneItem);
                    this.fields.splice(event.added.newIndex, 0, cloneItem);
                }).catch((err) => {
                    this.$toast.error("Hata oluşmaktadır.");

                });






            }
            if (event.moved != undefined) {


                this.fields.splice(event.moved.oldIndex, 1);
                this.fields.splice(event.moved.newIndex, 0, event.moved.element);
                //this.fields.splice(event.moved.oldIndex, event.moved.newIndex);
            }




            //if (event.moved) {



            //    //const element = event.moved.element;
            //    //console.log(element.name);

            //    //// +2 to insert into myArray[2] as non draggable items are in spots 0,1
            //    //const indexToInsert = event.moved.newIndex + 2;
            //    //console.log(indexToInsert);

            //    ////remove element from model
            //    //for (let i = 0; i < this.myArray.length; i++) {
            //    //    if (this.myArray[i].name === element.name) {
            //    //        this.myArray.splice(i, 1);
            //    //    }
            //    //}

            //    //// insert element into proper place
            //    //this.myArray.splice(indexToInsert, 0, element);
            //    //console.log('Finished onChange');
            //    //console.log(this.myArray);
            //}
        },
        newGuid() {
            return Array.from(Array(32))
                .map((e, i) => {
                    let someRandomValue = i === 12 ? 4 : (+new Date() + Math.random() * 16) % 16 | 0;
                    return `${~[8, 12, 16, 20].indexOf(i) ? "-" : ""}${(i === 16 ? someRandomValue & 0x3 | 0x8 : someRandomValue).toString(16)}`;
                }).join("");
            //return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            //    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            //);
        },
        cloneYellow() {
            return true;
        },
        seciliItemHaricDigerItemlar() {
            return this.fields.filter(m => this.selectedField.id != m.id).map((m) => { return { id: m.id, name: m.label } });
        },
        triggerChange(value) {
            if (value) {
                this.selectedField.triggerItems = this.fields.filter(m => this.selectedField.id != m.id).map((m) => { return { id: m.id, name: m.label } });
            }
            else {
                this.selectedField.triggerItems = [];
                this.selectedField.deleteSelectItem = null;
            }

            //this.selectedField.triggerItems = this.fields.filter(m => this.selectedField.id != m.id)//.map((m) => { return { id: m.id, label = m.label } });
        },
        triggerSelectedItemChange(value) {

            var selectedItem = this.fields.find(m => value == m.id);
            if (selectedItem != null) {
                this.selectedField.triggerSelectedItemItems = selectedItem.items2.map((m) => { return m.name });
            }
        },
        //triggerSelect(field) {
        //    if (field.tetiklenecekItemIdleri.length > 0) {
        //        field.tetiklenecekItemIdleri.forEach(m => {

        //            var selectedItem = this.fields.find(fieldItem => m == fieldItem.id);
        //            selectedItem.items2= selectedItem.items3.filter(item => item.parent == field.value);
        //        })
        //    }
        //},
        save() {
            //this.fields.
        }

    }
}
</script>
<style scoped>
.drop-zone {
    min-height: 200px;
    padding: 10px;
    border: 2px dashed #ccc;
    background-color: #fafafa;
    /* height: 90vh; */
    height: calc(100vh - 190px);
    overflow-y: scroll;
}

.card-content {
    height: calc(100vh - 165px);
}

.action-top-right {
    position: absolute;
    top: 4px;
    right: 4px;
    display: flex;
    /* yatay hizalama */
    flex-direction: row;
    /* yan yana */
    gap: 4px;
    /* butonlar arası boşluk */
}

.selectdItemClass {
    background-color: #F0FFF0;
}

.disabled {
    opacity: 0.5;
    background: gray;
    pointer-events: none;
    user-select: none;
}

.disabled .overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    padding: 5px 10px;
    border-radius: 4px;
    font-weight: bold;
}
</style>